import React from 'react';
import { TooltipWithTriggerIcon } from '@alfa-retail-react/components';

import { WEB_VISOR_HIDE } from 'app/utils/AnalyticsUtils';
import { FormatUtils } from 'app/utils/FormatUtils';
import { FieldSet } from 'app/component/fieldset/FieldSet';
import { RkkCardProduct } from 'app/model/product/RkkCardProduct';
import { CardOrder } from 'app/model/CardOrder';
import { useIsDesktop } from 'app/utils/useWindowType';

export interface RkkProductDetailsProps {
    rkkCardProduct: RkkCardProduct;

    order: CardOrder;
}

/**
 * Блок параметров продукта
 * Отображается на начальной странице и странице подтверждения данных заявки
 * @param rkkCardProduct
 * @param order
 * @constructor
 */
export const RkkProductDetails = ({
    rkkCardProduct,
    order,
}: RkkProductDetailsProps) => {
    const insurance = rkkCardProduct.insurance.find(
        ({ code }) => code === order.insuranceProductCode,
    );
    const [isDesktop] = useIsDesktop();
    const {
        commissionAmount,
        currency,
        installmentRate,
        installmentTerm,
        maxAmount,
        rate,
    } = rkkCardProduct;

    return (
        <>
            <FieldSet
                className={'productDetailsFieldSet'}
                fieldsProps={[
                    {
                        className: 'limit',
                        title: 'Кредитный лимит',
                        value: (
                            <span>
                                до {FormatUtils.toIntegerString(maxAmount)}{' '}
                                <span className="currency">{currency}</span>
                            </span>
                        ),
                        isVisible: !order.amount,
                    },
                    {
                        className: 'limit',
                        title: 'Кредитный лимит',
                        value: (
                            <span className={WEB_VISOR_HIDE}>
                                {!!order.amount &&
                                    FormatUtils.toIntegerString(
                                        order.amount,
                                    )}{' '}
                                <span className="currency">
                                    {order.currency}
                                </span>
                            </span>
                        ),
                        isVisible: !!order.amount,
                    },
                    {
                        className: 'graceRate',
                        title: 'Ставка',
                        value: `от ${FormatUtils.toPercentString(
                            installmentRate,
                        )} %`,
                        tooltip: () => (
                            <TooltipWithTriggerIcon
                                title="Ставка"
                                isDesktop={isDesktop}
                                content={
                                    'Процент зависит от срока, на который вы делите оплату на части. ' +
                                    'Чем больше месяцев, тем выше процент. Вы сами решаете, на какой срок разделить покупку. ' +
                                    'Это можно сделать в приложении INSNC или по СМС'
                                }
                            />
                        ),
                    },
                    {
                        className: 'term',
                        title: 'Срок платежа',
                        value: `до ${installmentTerm} мес`,
                    },
                    {
                        className: 'rate',
                        title: 'Ставка по кредиту',
                        value: `${FormatUtils.toPercentString(rate)} %`,
                        tooltip: () => (
                            <TooltipWithTriggerIcon
                                title="Ставка по кредиту"
                                content={
                                    <div>
                                        Ставка по кредиту применится:
                                        <ol>
                                            <li>На сумму операции до 50 BYN</li>
                                            <li>
                                                На любую сумму операции, если вы
                                                не разделите покупку на части в
                                                приложении или по СМС
                                            </li>
                                        </ol>
                                    </div>
                                }
                                isDesktop={isDesktop}
                            />
                        ),
                    },
                    {
                        className: 'commission',
                        title: 'Обслуживание карты',
                        value: (
                            <span>
                                {FormatUtils.toDecimalString(commissionAmount)}{' '}
                                <span className="currency">{currency}/мес</span>
                            </span>
                        ),
                    },
                    //https://projects.alfabank.by/browse/CC2C-199
                    // {
                    //     className: 'grantTerm',
                    //     title: 'Срок предоставления',
                    //     value: rkkCardProduct.grantTerm,
                    // }
                    {
                        className: 'insurance',
                        title: 'Страховой взнос',
                        value: (
                            <span>
                                {!!insurance?.amount &&
                                    FormatUtils.toIntegerString(
                                        insurance?.amount,
                                    )}{' '}
                                <span className="currency">{currency}</span>
                            </span>
                        ),
                        isVisible: !!insurance,
                    },
                ]}
            />
        </>
    );
};
